export default "__VITE_ASSET__7ab718dd__"